<script>
    import Spinner from '~/components/Spinner.svelte';
    import { auth, authState } from '~/firebase';
    import { onMount } from 'svelte';
    import { navigate } from 'svelte-routing';

    onMount(async () => {
        await auth.handleSignInRedirect();

        navigate('/');
    });
</script>

<Spinner />